module.exports = __webpack_public_path__ + "img/fgh_al.51258e12.jpg";